var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checked-box") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch Beta.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "inherit",
    strokeWidth: 1,
    fill: "inherit",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workflow-Creation",
    transform: "translate(-379.000000, -780.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked-box",
    transform: "translate(379.000000, 780.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-19-Copy",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 2,
    stroke: "none",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-17-Copy-4",
    fill: "none",
    stroke: "inherit",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "6 10.2495949 8.66312 12.5175928 13.5166762 7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBox);
export default __webpack_public_path__ + "static/media/checked-box.79c2c7d049b0e2939a1fc69c33528475.svg";
export { ForwardRef as ReactComponent };